/**
 * @file 个人中心 store
 * @author jiaojian04
 */

import {get} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';
import {Url} from '@/utils/api';
import {scrollToId} from '@/utils/decorate/scroll';

const {
    userHomeUrl,
    userHomeTopicListUrl,
    userHomeReplyListUrl
} = Url;

export default {
    state: {
        info: {},
        isSelf: false,
        listType: 'topic',
        topicTotal: -1,
        replyTotal: -1,
        topicInfo: {
            topicList: [],
            pageInfo: {}
        },
        replyInfo: {
            replyList: [],
            pageInfo: {}
        }
    },
    mutations: {
        setUserHomeNickname(state, nickname) {
            state.info.nickname = nickname;
        },
        setUserHomeInfo(state, info) {
            state.info = info;
        },
        setIsSelf(state, isSelf) {
            state.isSelf = isSelf;
        },
        setTopicTotal(state, data) {
            state.topicTotal = data;
        },
        setReplyTotal(state, data) {
            state.replyTotal = data;
        },
        setUserHomeReplyList(state, data) {
            state.replyInfo.replyList = data.replyList;
            state.replyInfo.pageInfo = data.pageInfo;
        },
        setUserHomeTopicList(state, data) {
            state.topicInfo.topicList = data.topicList;
            state.topicInfo.pageInfo = data.pageInfo;
        },
        concatUserHomeTopicList(state, data) {
            state.topicInfo.topicList = state.topicInfo.topicList.concat(data.topicList);
            state.topicInfo.pageInfo = data.pageInfo;
        },
        concatUserHomeReplyList(state, data) {
            state.replyInfo.replyList = state.replyInfo.replyList.concat(data.replyList);
            state.replyInfo.pageInfo = data.pageInfo;
        }
    },
    actions: {
        getUserHomeInfo({commit, state}, {userNo, listType, pageNo}) {
            get(userHomeUrl, {
                userNo,
                listType: state.listType,
                pageNo: pageNo || 1
            }).then(data => {
                commit('setUserHomeInfo', data.userInfo);
                commit('setTopicTotal', data.topicTotal);
                commit('setReplyTotal', data.replyTotal);
                commit('setIsSelf', data.isSelf);
                if (state.listType === 'reply') {
                    commit('setUserHomeReplyList', {
                        replyList: data.replyList,
                        pageInfo: data.pageInfo
                    });
                }
                else {
                    commit('setUserHomeTopicList', {
                        topicList: data.topicList,
                        pageInfo: data.pageInfo
                    });
                }
            }).catch(err => {
                toast.error(err && err.message);
            });
        },
        getUserHomeTopicList({commit, state}, {userNo, pageNo, loadMore = false}) {
            if (loadMore && state.topicInfo.pageInfo) {
                pageNo = +state.topicInfo.pageInfo.pageNo + 1;
            }
            get(userHomeTopicListUrl, {
                userNo,
                pageNo: pageNo || 1
            }).then(data => {
                if (loadMore) {
                    commit('concatUserHomeTopicList', {
                        topicList: data.topicList,
                        pageInfo: data.pageInfo
                    });
                }
                else {
                    scrollToId('user-home-list-tabs');
                    commit('setUserHomeTopicList', {
                        topicList: data.topicList,
                        pageInfo: data.pageInfo
                    });
                }
                commit('setTopicTotal', data.pageInfo.recordTotal);
            }).catch(err => {
                toast.error(err && err.message);
            });
        },
        getUserHomeReplyList({commit, state}, {userNo, pageNo, loadMore = false}) {
            if (loadMore && state.replyInfo.pageInfo) {
                pageNo = +state.replyInfo.pageInfo.pageNo + 1;
            }
            get(userHomeReplyListUrl, {
                userNo,
                pageNo: pageNo || 1
            }).then(data => {
                if (loadMore) {
                    commit('concatUserHomeReplyList', {
                        replyList: data.replyList,
                        pageInfo: data.pageInfo
                    });
                }
                else {
                    scrollToId('user-home-list-tabs');
                    commit('setUserHomeReplyList', {
                        replyList: data.replyList,
                        pageInfo: data.pageInfo
                    });
                }
                commit('setReplyTotal', data.pageInfo.recordTotal);
            }).catch(err => {
                toast.error(err && err.message);
            });
        }
    }
};
